import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import Validator from "validator";
import { Capacitor } from "@capacitor/core";

import {login, acceptEULA, checkEULA} from "./actions/userAction";
import {Layout} from "../../shared/components/Layout";
import Footer from "../../shared/components/Footer";
import {InputFieldGroup} from "../../shared/components/InputFieldGroup";
import {NOTIFICATION_ERROR} from "../../shared/modules/notification/constants";
import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import {
  ROUTER_ROOT,
  ROUTER_USER_PASSWORD_REQUEST,
  ROUTER_DOWNLOADS
} from "../../shared/constants/routers";
import Popup from "../../shared/containers/Popup";
import version from '../../../../version.json';
import {isDeviceMobile} from "../../shared/actions";

class Login extends React.Component {

  static propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    errors: PropTypes.object,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    email: "",
    password: "",
    errors: {},
    isLoading: false
  };

  state = {
    email: "",
    password: "",
    errors: {},
    isLoading: false
  };

  closePopup() {
    this.setState({
      showPopup: false
    });
    acceptEULA(version);
  }

  validateInput(data) {
    const errors = {};
    let isValid = true;

    if (Validator.isEmpty(data.email)) {
      errors.email = __("Please enter an e-mail address.");
      isValid = false;
    }

    if (Validator.isEmpty(data.password)) {
      errors.password = __("Please enter a password.");
      isValid = false;
    }

    return {errors, isValid: isValid};
  }

  onSubmit = (event) => {
    event.preventDefault();
    this.setState({errors: {}, isLoading: true});

    const {errors, isValid} = this.validateInput(this.state);
    const {email, password} = this.state;

    if (isValid) {
      this.props.dispatch(login(email, password))
        .then(() => {
          if(!Capacitor.isNative && isDeviceMobile()) this.props.history.push(ROUTER_DOWNLOADS);
          else this.props.history.push(ROUTER_ROOT);
        })
        .catch((err, res) => {
          if (typeof err.status === "undefined" && typeof res === "undefined") {
            this.props.dispatch(
              notificationAction.addNotification(
                __("You are offline right now. Please check your internet connection and try again."),
                NOTIFICATION_ERROR
              )
            )
          } else {
            this.props.dispatch(
              notificationAction.addNotification(
                __("Error: Please check your input"),
                NOTIFICATION_ERROR
              )
            );
          }
          this.setState({isLoading: false});
        });
    } else {
      this.setState({errors: errors, isLoading: false});
    }
  };

  onChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  };

  render() {
    const {errors, email, password, isLoading} = this.state;

    return (
      <div>
        {!checkEULA(version) && <Popup closePopup={this.closePopup.bind(this)}/>}
        <Layout title={__("Family Portal")}>
          <form
            id="login"
            className="flexBox direction-column flex"
            onSubmit={this.onSubmit}
          >
            <InputFieldGroup
              name="email"
              type="email"
              placeholder={__("E-Mail")}
              value={email}
              onChange={this.onChange}
              error={errors.email}
            />
            <InputFieldGroup
              name="password"
              type="password"
              placeholder={__("Password")}
              value={password}
              onChange={this.onChange}
              error={errors.password}
            />
            <button className="buttonPrimary" disabled={isLoading}>
              {__("Log in now")}
            </button>
            <Link to={ROUTER_USER_PASSWORD_REQUEST} className="buttonSecondary">
              {__("Forgot Password?")}
            </Link>
          </form>
          <Footer/>
        </Layout>
      </div>
    );
  }
}

export default connect()(Login);
